import "./App.css";
import react, { useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import { ToastProvider } from "./provider/ToastContext";
import Dashboard from "./components/Dashboard";
import SupportForm from "./components/SupportForm";
import Sidebar from "./components/Sidebar";
import TermsConditions from "./components/TermsConditions";
import TestPage from "./components/TestPage";
import Login from "./components/auth/Login";
import GoogleAuth from "./components/auth/GoogleAuth";
import OAuthSuccess from "./components/auth/OAuthSuccess";
import ForgotPasswordEmail from "./components/auth/ForgotPasswordEmail";
import Signup from "./components/auth/Signup";
import CreateTweet from "./components/blogtotweet/CreateTweet";
import SavedPosts from "./components/blogtotweet/SavedPosts";
import RecentlyGenerated from "./components/blogtotweet/RecentlyGenerated";
import SimplePay from "./components/profile/SimplePay";
import Success from "./components/profile/Success";
import SetPassword from "./components/profile/SetPassword";
import UserProfile from "./components/profile/UserProfile";
import BillingDetails from "./components/profile/BillingDetails";
import Checkout from "./components/profile/Checkout";
import CreateClip from "./components/longtoshorts/CreateClip";
import SavedShorts from "./components/longtoshorts/SavedShorts";

function AppLayout() {
  const location = useLocation();
  const hideSidebarRoutes = ["/login", "/signup", "/termsandconditions"];
  const isAuthenticated = !!localStorage.getItem("token");
  const shouldShowSidebar =
    isAuthenticated && !hideSidebarRoutes.includes(location.pathname);

  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    const stored = localStorage.getItem("sidebarCollapsed");
    return stored === "true";
  });

  const toggleSidebar = () => {
    const newValue = !sidebarCollapsed;
    setSidebarCollapsed(newValue);
    localStorage.setItem("sidebarCollapsed", newValue.toString());
  };

  return (
    <ToastProvider>
      <div>
        {shouldShowSidebar && (
          <Sidebar
            collapsed={sidebarCollapsed}
            toggleCollapse={toggleSidebar}
          />
        )}
        <div>
          <main className="py-10">
            <div className="pl-8 pr-12 col-span-3 gap-1">
              <Routes>
                <Route
                  path="/termsandconditions"
                  element={<TermsConditions />}
                />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/test" element={<TestPage />} />
                <Route path="/success" element={<Success />} />
                <Route
                  path="/gauth"
                  element={<GoogleAuth></GoogleAuth>}
                ></Route>
                <Route path="/oauth/success" element={<OAuthSuccess />} />
                <Route
                  path="/forgotpassword"
                  element={<ForgotPasswordEmail />}
                />
                <Route path="/setpassword" element={<SetPassword />} />
                <Route path="/checkout" element={<Checkout />} />

                <Route element={<ProtectedRoute />}>
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route
                    path="/createposts"
                    element={<CreateTweet collapsed={sidebarCollapsed} />}
                  />
                  <Route
                    path="/createshorts"
                    element={<CreateClip collapsed={sidebarCollapsed} />}
                  />
                  <Route
                    path="/savedposts"
                    element={<SavedPosts collapsed={sidebarCollapsed} />}
                  />
                  <Route
                    path="/savedshorts"
                    element={
                      <SavedShorts collapsed={sidebarCollapsed}></SavedShorts>
                    }
                  ></Route>
                  <Route
                    path="/recentlygenerated"
                    element={<RecentlyGenerated collapsed={sidebarCollapsed} />}
                  />
                  <Route path="/simplepay" element={<SimplePay />} />
                  <Route
                    path="/profile"
                    element={<UserProfile collapsed={sidebarCollapsed} />}
                  />
                  <Route
                    path="/billingdetails"
                    element={<BillingDetails collapsed={sidebarCollapsed} />}
                  />
                  <Route
                    path="/support"
                    element={<SupportForm collapsed={sidebarCollapsed} />}
                  />
                </Route>
              </Routes>
            </div>
          </main>
        </div>
      </div>
    </ToastProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppLayout />
    </BrowserRouter>
  );
}

export default App;
